import { Router, NavigationEnd } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import {
  trigger,
  transition,
  animate,
  style,
} from '@angular/animations';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy,
  AfterViewInit,
  DestroyRef,
  inject
} from '@angular/core';
import { UtilService } from '../../core/service/util.service';
import { SideBarItems } from './sidebar-items';
import { Observable, Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GraphQLBaseService } from 'src/app/module_services/graphql-base.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    trigger('flyInOut', [
      transition('default => settings', [
        style({ transform: 'translateX(100%)' }), // right to left
        animate('300ms', style({ transform: 'translateX(0)' })),
      ]),
      transition('settings => default', [
        style({ transform: 'translateX(-100%)' }), // left to right
        animate('300ms', style({ transform: 'translateX(0)' })),
      ]),
    ]),
  ],
})

export class SidebarComponent implements OnInit, OnDestroy, AfterViewInit {
  stopSignal = new Subject();
  actionObservable!: Observable<any>;
  time: any;
  logo:string = this._util.theme !== 'menu_dark' ? 'logo-icon-primary.png' : 'logo.svg'
  clock_in_restrictions: any;
  // employee_info = this.authService.currentUserValue.profile.employee;
  org: any;
  profile: any;
  settings: boolean = true;
  authorizedModules: any;
  isIconTouched: boolean = true;
  menuType!: string;
  translateYValue: string = '0px';
  previousActiveIndex: number = 0
  previousActive!: string;
  public sidebarItems!: any[];
  public settingsItems!: any[];
  level1Menu: any = {
    name: '',
    type: ''
  };
  level2Menu = '';
  level3Menu = '';
  homePage: string = '';
  public innerHeight: any;
  public bodyTag: any;
  listMaxHeight!: string;
  listMaxWidth!: string;
  userFullName!: string;
  userImg!: string;
  userType!: string;
  currentRoute!: string;
  routerObj: any;
  position: any;
  showAnimatedIcons: boolean = true;
  isFirstLevelHovered: boolean = false;
  displaySecondLevel: number = -1;
  displayThirdLevel: number = -1;
  activeSecondLevelIndex: number = -1;
  currentUser: any;
  superUser: any;
  currentUserPermission: any;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    public router: Router,
    public _util: UtilService,
    private _base: GraphQLBaseService,
    private sidebar: SideBarItems,
  ) {
    this.getActivePath();
    this.bindSidebarActiveIcon();
  }

  getActivePath(isPanelNavigation?: boolean) {
    this.routerObj = this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // logic for select active menu in dropdown
        this.setActiveState(event.url.split('/'));
      }
    });
    if (isPanelNavigation) {
      this.setActiveState(this.router.url.split('/'));
    }
  }

  private bindSidebarActiveIcon(): void {
    this._util.sidebarActiveIcon
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: any) => {
        if (res) {
          this.position = res;
        }
      });
  }

  setActiveState(urls: any) {
    const rawUrl = urls.length > 2 ? urls.join('/') : urls.join('');
    const url = String(rawUrl).split('?')[0].split('#')[0];
    const sidebar_items = this.sidebar.getSideBarItems();
    sidebar_items.forEach((firstLevel) => {
      if(firstLevel.path == url) {
        this.level1Menu.name = firstLevel.moduleName;
        this.level1Menu.type = firstLevel.type;
      }
      else if(!url) {
        this.level1Menu.name = 'home';
        this.level1Menu.type = 'default';
      }
      if(firstLevel?.submenu.length > 0) {
        firstLevel.submenu.forEach((secondLevel: any) => {
          if(secondLevel.path == url) {
            this.level1Menu.name = firstLevel.moduleName;
            this.level1Menu.type = firstLevel.type;
            this.level2Menu = secondLevel.moduleName;
          }
          if(secondLevel.submenu.length > 0) {
            secondLevel.submenu.forEach((thirdLevel: any) => {
              if(thirdLevel.path === url) {
                this.level1Menu.name = firstLevel.moduleName;
                this.level1Menu.type = firstLevel.type;
                this.level2Menu = secondLevel.moduleName;
                this.level3Menu = thirdLevel.moduleName;
              }
            });
          }
        });
      }
    });
    this.menuType = urls[1] === 'settings' ? 'settings' : 'default';
    this._util.changeLeftSidebarMenuType(this.menuType);
    this.initLeftSidebar();

    // close sidebar on mobile screen after menu select
    this.renderer.removeClass(this.document.body, 'overlay-open');
  }

  ngAfterViewInit(): void {
    this.renderer.removeClass(this.document.body, 'display-tab-content');
  }

  @HostListener('window:resize', ['$event'])
  windowResizecall() {
    this.setMenuHeight();
    this.checkStatuForResize();
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: any): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, 'overlay-open');
    }
  }

  ngOnInit() {
    this.rolesAndPermissions();
    const urlParts = this.router.url.split('/').filter(Boolean);
    this.menuType = urlParts[0] === 'settings' ? 'settings' : 'default';
    this._util.changeLeftSidebarMenuType(this.menuType);
    this.initLeftSidebar();
    this.bodyTag = this.document.body;
  }
  rolesAndPermissions() {
    /* this.currentUser = this.authService?.currentUser?.subscribe({
      next: (res: any) => {
        this.superUser = res?.profile?.superuser;
        if (res?.profile?.superuser !== true || res?.permissions && res?.permissions?.length > 0) {
          this.currentUserPermission = res.permissions;
        }
      },
      error: (err: ApolloError) => {
      },
      complete: () => { }
    }) */
  }

  ngOnDestroy() {
    this.routerObj?.unsubscribe();
    this.stopSignal.next(null);
    this.stopSignal.complete();
  }

  initLeftSidebar() {
    this.setSidebarItems();
    // Set menu height
    this.setMenuHeight();
    this.checkStatuForResize();
  }

  setSidebarItems() {
    const utilMenuType = this._util.getLeftSidebarMenuType;
    if (utilMenuType) {
      this.menuType = utilMenuType;
    } else {
      const urlParts = this.router.url.split('/').filter(Boolean);
      this.menuType = urlParts[0] === 'settings' ? 'settings' : 'default';
      this._util.changeLeftSidebarMenuType(this.menuType);
    }
    this.sidebarItems = this.sidebar.getSideBarItems().filter((x) => x.type === this.menuType);
    // this.sidebarItems = this.authService.getPermittedMenu(this.sidebarItems, true);
    const index = this.sidebarItems.findIndex((obj: any) => obj.moduleName === this.level1Menu.name);
    if (this.sidebarItems[index]?.position) {
      this.position = this.sidebarItems[index]?.position;
    }
    else {
      this.showAnimatedIcons = false;
    }
  }

  doDisplaySettings() {
    let isDisplaySettings = false;
    if (this.profile?.superuser) {
      isDisplaySettings = true
    } else if (this.settings) {
      isDisplaySettings = true
    }

    return isDisplaySettings;
  }

  toggleSideMenu(type: string) {
    this.setActiveState(this.router.url.split('/'));
    this._util.changeLeftSidebarMenuType(type);
    this.showAnimatedIcons = false;
    this.displaySecondLevel = -1;
    this.setSidebarItems();
  }

  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - 100;
    this.listMaxHeight = height + '';
    this.listMaxWidth = '500px';
  }

  callLevel1Toggle() {
    this.renderer.removeClass(this.document.body, 'display-tab-content');
  }
  callLevel2Toggle(event: any, element: any) {
    if (element === this.level2Menu) {
      this.level2Menu = '0';
    } else {
      this.level2Menu = element;
    }
  }

  callLevel3Toggle(event: any, element: any) {
    if (element === this.level3Menu) {
      this.level3Menu = '0';
    } else {
      this.level3Menu = element;
    }
  }

  showProfileModel() {
    this.isIconTouched = !this.isIconTouched;
  }

  isOpen() {
    return this.bodyTag.classList.contains('overlay-open');
  }

  checkStatuForResize() {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, 'ls-closed');
    } else {
      this.renderer.removeClass(this.document.body, 'ls-closed');
    }
  }

  positionCheck(index: any) {
    this.showAnimatedIcons = true;
    this._util.sidebarActiveIcon.next(this.sidebarItems[index].position);
    this.router.navigate([`${this.sidebarItems[index].path}`])
  }

  panelNavigation(url: string, index: number) {
    this.routerObj.unsubscribe();
    setTimeout(() => {
      this.router.navigate([url]).then(() => {
        this.getActivePath(true);
        this.initLeftSidebar();
      })
    }, 5);
  }

  trackBySidebarItem(_index: number, item: { moduleName?: string; path?: string; title?: string }): string {
    return `${item?.moduleName ?? ''}|${item?.path ?? ''}|${item?.title ?? ''}`;
  }

  trackByIndex(index: number): number {
    return index;
  }

}